import { BORDER_BETWEEN_LOCATIONS_POSITION, POSSIBILITY_MOOVENETS_DISTANCE } from "../../constants/game-constants";
import { NotepadPathPoints, PATH_POINTS } from "../../constants/parh-points";
import { GamePoint } from "../../interfaces/common-interfaces";
import { GameStateService } from "../../services/game-state/game-state.service";
import { getNearestPathPoint, getPointDistanse, getPointIndex, isEquil } from "../common/helpers";
import { take } from "rxjs";

export class Path {
  state: GameStateService;

	currentLocation: 0 | 1 | 2 = 0;

	prevPoint: GamePoint;

	nextPoint: GamePoint | null;

	private _path: GamePoint[] = [];
	public get path(): GamePoint[] {
		return this._path;
	}
	public set path(value: GamePoint[]) {
		this._path = value;
	}

	pathIsStarted = false;

	allPathPoints: GamePoint[];

	clickedPointMap = new Map();

  constructor(state: GameStateService) {
		this.state = state;

    this.init();
  }

  init() {
		this.collectAllPathPoints();

    this.initSubscribers();
  }

  initSubscribers() {
		this.state.signal.fieldClicked.subscribe(point => {
			this.nextPoint = getNearestPathPoint(point, this.allPathPoints);

			this.clickedPointMap.clear();
			this.clickedPointMap.set(`${this.nextPoint[0]}_${this.nextPoint[1]}`, point);

			if (this.isPossibilityMoovement(point)) {
				this.calculateNextPoint();
			}
		});
  }

	public collectAllPathPoints() {
		this.allPathPoints = [...PATH_POINTS[0]];
		let completedLocation = this.state.getGameStatus('completedLocation');
		if (completedLocation >= 1) {
			this.allPathPoints = [...this.allPathPoints, ...PATH_POINTS[1]];
			this.allPathPoints = [...this.allPathPoints, ...PATH_POINTS[2]];
			this.allPathPoints = [...this.allPathPoints, ...PATH_POINTS[3]];
			this.allPathPoints = [...this.allPathPoints, ...PATH_POINTS[4]];
			this.allPathPoints = [...this.allPathPoints, ...PATH_POINTS[5]];
		}
	}

	public getCurrentLocation(point: GamePoint) {
		let currentLocation = 0;
		PATH_POINTS.forEach((location, i) => {
			if (location.some(p => isEquil(point, p))) {
				currentLocation = i;
			}
		});
		return currentLocation;
	}

  private isPossibilityMoovement([x, y]: GamePoint) {
		const distanse = getPointDistanse([x, y], this.nextPoint!);
		return !this.pathIsStarted && distanse < POSSIBILITY_MOOVENETS_DISTANCE;
	}

  private calculateNextPoint() {
		const currentPoint = this.state.player.currentPosition;
		if (!this.nextPoint || isEquil(this.nextPoint!, currentPoint) || this.state.gamePause) {
			this.pathEnded();
			return;
		}

		if (!this.pathIsStarted) this.state.sound.play('steps', {loop: true, volume: 1.2});

		let middlePoint: GamePoint;

		const path = [...this.allPathPoints];
		const currentPointIndex = getPointIndex(currentPoint, path);
		let nextPointIndex = getPointIndex(this.nextPoint, path);

		if (currentPointIndex < nextPointIndex) {
			middlePoint = path[currentPointIndex + 1];
		} else {
			middlePoint = path[currentPointIndex - 1];
		}

		if (middlePoint[1] < BORDER_BETWEEN_LOCATIONS_POSITION) {
			this.currentLocation = 1;
		} else {
			this.currentLocation = 0;
		}

    this.pathIsStarted = true;
		let currentLocation = localStorage.getItem('currentLocation') || 1;
		this.state.player.goToPoint(middlePoint).then(() => {
      this.state.changeGameStatus('savedPlayerPosition', middlePoint);
			if (isEquil(middlePoint, [1080, 620])) {
				currentLocation = 1;
				localStorage.setItem('currentLocation', `${currentLocation}`);
				// console.log('currentLoc', currentLocation);
				this.state.sound.playFon();
			} else if (isEquil(middlePoint, [1040, 600]) || isEquil(middlePoint, [1120, 190])) {
				currentLocation = 2;
				localStorage.setItem('currentLocation', `${currentLocation}`);
				// console.log('currentLoc', currentLocation);
				this.state.sound.playFon();
			} else if (isEquil(middlePoint, [1160, 160]) || isEquil(middlePoint, [1800, -260])) {
				currentLocation = 3;
				localStorage.setItem('currentLocation', `${currentLocation}`);
				// console.log('currentLoc', currentLocation);
				this.state.sound.playFon();
			} else if (isEquil(middlePoint, [1840, -290]) || isEquil(middlePoint, [420, -1310])) {
				currentLocation = 4;
				localStorage.setItem('currentLocation', `${currentLocation}`);
				// console.log('currentLoc', currentLocation);
				this.state.sound.playFon();
			} else if (isEquil(middlePoint, [500, -1360])) {
				currentLocation = 5;
				localStorage.setItem('currentLocation', `${currentLocation}`);
				// console.log('currentLoc', currentLocation);
				this.state.sound.playFon();
			}
			const lastNotepadPathPoint = localStorage.getItem('lastNotepadPathPoint');
			if (NotepadPathPoints.some((p, i) => isEquil(middlePoint, p))) {
				const index = NotepadPathPoints.findIndex(p => isEquil(middlePoint, p)) + 1;
				if (lastNotepadPathPoint && lastNotepadPathPoint < index.toString() || !lastNotepadPathPoint) {
					localStorage.setItem('lastNotepadPathPoint', index.toString());
				}
			}
			// console.log(middlePoint);
      this.state.signal.lastPassedPoint.next(middlePoint);
			this.calculateNextPoint();
		});
	}

	pathEnded() {
		this.pathIsStarted = false;
		let clickedPoint;
		if (this.nextPoint) {
			clickedPoint = this.clickedPointMap.get(`${this.nextPoint[0]}_${this.nextPoint[1]}`);
			this.clickedPointMap.clear();
		}
		this.nextPoint = null;
    this.state.signal.pathEnded.next(clickedPoint);

		this.state.sound.stop('steps');
	}

}